import { AuthenticationProvider } from "domain/authentication";
import React from "react";
import ReactDOM from "react-dom/client";
import { GlobalRouter } from "router";
import reportWebVitals from "./reportWebVitals";
import "./style/index.scss";
import { loadEmbeddedChatService } from "domain/chat";
import { CookiesProvider } from "react-cookie";

loadEmbeddedChatService();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <CookiesProvider>
      <AuthenticationProvider>
          <GlobalRouter />
      </AuthenticationProvider>
    </CookiesProvider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
